import watch from "redux-watch";
import { checkForm } from "../utils/errorHandling";
import template from "modal/find-registry.j2";
import { render } from './coreComponent';
import { generate } from "../../../core/js/utils/componentUtils";
import { mDom, mDomMaintainInputVals } from '../../../core/js/utils/renderUtils';
import { sendFindRegistryData, clearRegistryData } from '../actions/findRegistryModalActions';

export function init(store, overrides = {}) {
    const config = {
        attachEvents: attachEvents,
        firstRender: firstRender,
        watch: 'core.modal.findRegistry',
        template: template,
        name: 'modal.findRegistry',
        replace: 'once',
        afterCloseAction: afterCloseAction,
        renderType: mDom,
        renderOptions: mDomMaintainInputVals
    };

    return generate(config, store, overrides);
}

function firstRender(store) {
    this.render(store, this);
    attachParsley(this, store);
}

function afterCloseAction(store) {
    store.dispatch(clearRegistryData());
}

/**
 * Attach component events to DOM
 * @returns {undefined}
 */
function attachEvents(store) {
    $(document).on(this.scopedEvent('submit'), this.scopedSelector('.js-find-registry'), (e) => {
        e.preventDefault();

        const queryString = $('.js-find-registry').serialize();

        window.location.href = `/registry/search?${queryString}`;
    });
}

function attachParsley(component, store) {
    $(component.scopedSelector('.js-find-registry')).parsley().on('field:validated', (e) => {
        const [values, msgs] = checkForm(component.scopedSelector('.js-find-registry'));

        store.dispatch(sendFindRegistryData(values, msgs));
    });
}
